import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import RecipesList from "../components/RecipesList"
import SEO from "../components/SEO"
import ContactForm from "../components/ContactForm"

const Contact = ({ data }) => {
  const recipes = data.allContentfulRecipe.nodes
  return (
    <Layout>
      <SEO title="Contact"/>
      <main className="page">
        <section className="contact-page">
          <article className="contact-info">
            <h3>How can I help you?</h3>
            {/* <p>
              I believe that my current skills can be transferred to any
              workplace and prove to be an asset to my future employer; this
              will enhance both our future growth and acknowledged achievements.
            </p> */}
            <p>
              I work well both independently and as part of a team, and work
              remote.{" "}
            </p>
            <p>
              If you have any queries or feedback, please feel free to message
              me.
            </p>
          </article>
          <article>
            <ContactForm/>
            {/* <form
              className="form contact-form"
              action="https://formspree.io/f/mleazbvq"
              method="POST"
            >
              <div className="form-row">
                <label htmlFor="name">your name</label>
                <input type="text" name="name" id="name" />
              </div>
              <div className="form-row">
                <label htmlFor="email">your email</label>
                <input type="text" name="email" id="email" />
              </div>
              <div className="form-row">
                <label htmlFor="message">message</label>
                <textarea name="message" id="message"></textarea>
              </div>
              <button type="submit" className="btn block">
                Message Me
              </button>
            </form> */}
          </article>
        </section>
        <section className="featured-recipes">
          <h5>My New Posts!!!</h5>
          <RecipesList recipes={recipes} />
        </section>
      </main>
    </Layout>
  )
}

export const query = graphql`
  {
    allContentfulRecipe(
      sort: { fields: title, order: ASC }
      filter: { featured: { eq: true } }
    ) {
      nodes {
        id
        title
      postDate
      postUpdate
        cookTime
        prepTime
        image {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
      }
    }
  }
`

export default Contact
